import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";










const helpers = {
  checkbox(data) {
    const requiredAttrs = ['id'];
    const reservedAttrs = [
      'type',
      'data-mask',
      'data-gis-mask',
    ];
    const combinableAttrs = {
      class: 'spa-input-option spa-input-option--checkbox',
      value: '',
    };
    const cbCount = data.checkboxes.length;
    const errorId = (cbCount === 1) ? data.checkboxes[0].checkbox.attrs.id : data.id;
    const dataHelpToggle = data.helpToggle ? data.helpToggle : data.label;


    const htmlToStrip = /<\/?[^>]+(>|$)/g;


    const inputLabelRequiredSpan = (required, asterisk) => {
      if (required) {
        return `<span class="spa-input-label--required">${(asterisk === false) ? '' : ' *'}</span>`;
      }
      return '';
    };

    let cbGroup = '';
    for (let i = 0; i < cbCount; i += 1) {
      const cbData = data.checkboxes[i];
      const attrsId = cbData.checkbox.attrs.id;
      const labelText = cbData.label.text;
      const cbRequired = cbData.required;
      const cbAsterisk = cbData.asterisk;
      const helpToggle = cbData.helpToggle ? cbData.helpToggle : cbData.label.text;

      if (!Handlebars.helpers.requiredAttrsCheck(cbData.checkbox.attrs, requiredAttrs).pass) {
        throw new Error(`You are missing the required attribute ${
          Handlebars.helpers.requiredAttrsCheck(cbData.checkbox.attrs, requiredAttrs).missingField
        }`);
      }

      const attrGroup = {};
      Handlebars.helpers.extend({}, attrGroup, cbData.checkbox.attrs);
      Handlebars.helpers.removeReservedAttrs(attrGroup, reservedAttrs);
      Handlebars.helpers.combineAttrs(attrGroup, combinableAttrs);
      const cbAttrs = Handlebars.helpers.buildAttrsString(attrGroup);

      let cbWrapper = `<div class="spa-input-options-wrapper${
        cbData.checkbox.attrs['data-help-body'] ? ' has-help' : ''
      }" ${
        cbData.checkbox.conditionalContent
          ? `data-option-has-conditional-content data-conditional-content="${
            cbData.checkbox.conditionalContent
          }"`
          : ''
      }>`;

      const cbHtml = `<input type="checkbox" ${cbAttrs
      } name="${data.name}" ${
        cbData.required || data.required
          ? `required aria-required="true" ${
            (typeof cbData.required === 'string')
              ? `data-required-error-message="${cbData.required}"`
              : ''
          }`
          : ''
      } ${
        (cbData.disabled || data.disabled) ? 'disabled aria-disabled="true"' : ''
      } aria-label="${
        cbData.label.adaText
          ? cbData.label.adaText.replace(htmlToStrip, '').replace(/"/g, '&quot;')
          : cbData.label.text.replace(htmlToStrip, '').replace(/"/g, '&quot;')
      }" /> <span class="spa-input-check">&nbsp;</span>`;

      const cbLabel = `<label class="spa-input-option-label" data-font="cnx-regular" for="${
        attrsId
      }" aria-hidden="true">${
        labelText
      }${
        inputLabelRequiredSpan(cbRequired, cbAsterisk)
      }</label>`;

      if (cbData.checkbox.attrs['data-help-body']) {

        const triggerText = cbData.checkbox.attrs['data-help-link'] || '';
        const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
        const cbHelpTrigger = `<a href="javascript:void(0);" id="help-open-${
          cbData.checkbox.attrs.id
        }" role="button" aria-label="${
          helpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }" class="${
          triggerClass
        }">${
          triggerText || '&nbsp;'
        }</a>`;

        let cbHelpContainer = `<div class="input-help" id="helpLayer_${
          cbData.checkbox.attrs.id
        }" role="tooltip" aria-hidden="true">`;

        const cbHelpClose = `<a href="javascript:void(0);" id="help-close-${
          cbData.checkbox.attrs.id
        }" role="button" aria-label="${
          helpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }" class="close-trigger svg-button">&nbsp;</a>`;

        let cbHelpBody = `<div class="body">${cbData.checkbox.attrs['data-help-body']}</div>`;

        if (cbData.checkbox.attrs['data-help-head']) {
          cbHelpBody = `<div class="head" data-font="cnx-bold">${
            cbData.checkbox.attrs['data-help-head']
          }</div>${
            cbHelpBody
          }`;
        }

        cbHelpContainer += `${cbHelpClose}${cbHelpBody}</div>`;
        cbWrapper += `${cbHtml}${cbLabel}${cbHelpTrigger}${cbHelpContainer}</div>`;
      } else {
        cbWrapper += `${cbHtml}${cbLabel}</div>`;
      }

      cbGroup += cbWrapper;
    }

    let cbGroupContainer = `<div class="spa-input spa-input-options spa-input--${
      (data.skin) ? data.skin : 'sparta2'
    } ${
      data.darkBackground ? 'spa-input-options--inverse' : ''
    } ${
      data.containerClasses ? `${data.containerClasses.join(' ')}` : ''
    }">`;

    const cbGroupWrapper = `<div class='spa-input-options-list--${
      data.direction || 'vertical'
    }'>${
      cbGroup
    }${
      data.direction ? '<div class="horizontal-clear"></div>' : ''
    }</div>`;

    const cbGroupHint = `<p class="spa-input-options-hint">${
      data.hintText ? data.hintText : ''
    }</p>`;

    const cbGroupError = `<div id="${
      errorId
    }_errorMessage" class="spa-input-error-message spa-icon--error" aria-hidden="true"></div>`;

    if (cbCount > 1) {

      const triggerText = data['data-help-link'] || '';
      const helpText = data['data-help-body'] || '';
      const clearfixClass = (helpText && !triggerText) ? 'clearfix' : '';
      const inlineTriggerClass = (helpText && !triggerText) ? 'inline-legend-icon' : '';

      let cbGroupFieldset = `<fieldset class="spa-fieldset ${
        clearfixClass
      }" id="${
        data.id
      }">`;

      const cbGroupFieldsetLabel = `<legend class="spa-fieldset-label ${
        inlineTriggerClass
      }" for="${data.id}">${
        data.label
      }${
        inputLabelRequiredSpan(data.required, data.asterisk)
      }</legend>`;

      if (data['data-help-body']) {
        const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
        const cbGroupHelpTrigger = `<a href="javascript:void(0);" id="help-open-${
          data.id
        }" role="button" aria-label="${
          dataHelpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }" class="${
          triggerClass
        }">${
          triggerText || '&nbsp;'
        }</a>`;

        let cbGroupHelpContainer = `<div class="input-help" id="helpLayer_${
          data.id
        }" role="tooltip" aria-hidden="true">`;

        const cbGroupHelpClose = `<a href="javascript:void(0);" id="help-close-${
          data.id
        }" role="button" aria-label="${
          dataHelpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }" class="close-trigger svg-button">&nbsp;</a>`;

        let cbGroupHelpBody = `<div class="body">${data['data-help-body']}</div>`;

        if (data['data-help-head']) {
          cbGroupHelpBody = `<div class="head" data-font="cnx-bold">${
            data['data-help-head']
          }</div>${
            cbGroupHelpBody
          }`;
        }

        cbGroupHelpContainer += `${cbGroupHelpClose}${cbGroupHelpBody}</div>`;
        cbGroupFieldset += `${
          cbGroupFieldsetLabel
        }${
          cbGroupHelpTrigger
        }${
          cbGroupHelpContainer
        }${
          cbGroupWrapper
        }${
          cbGroupHint
        }${
          cbGroupError
        }</fieldset>`;
      } else {
        cbGroupFieldset += `${
          cbGroupFieldsetLabel
        }${
          cbGroupWrapper
        }${
          cbGroupHint
        }${
          cbGroupError
        }</fieldset>`;
      }

      cbGroupContainer += `${cbGroupFieldset}</div>`;
    } else {
      cbGroupContainer += `${cbGroupWrapper}${cbGroupError}</div>`;
    }

    return new Handlebars.SafeString(cbGroupContainer);
  },
};


module.exports.register = (Handlebars) => {
  Object.keys(helpers).forEach((key) => {
    Handlebars.registerHelper(key, helpers[key]);
  });
};
module.exports.helpers = helpers;
